<template>
  <svg
    ref="svgchart"
    class="svgchart_svg"
    width="100%"
    height="100%"
    viewBox="0 0 1 1"
    preserveAspectRatio="none"
  >
    <g class="svgchart_svg_content">
      <SvgPath
        style="z-index: 0; position: relative"
        :pointsXY="ipPointsXY"
        class="svgchart_path svgchart_path_ip"
        vector-effect="non-scaling-stroke"
      />
      <SvgPath
        style="z-index: 0; position: relative"
        :pointsXY="oopPointsXY"
        class="svgchart_path svgchart_path_oop"
        vector-effect="non-scaling-stroke"
      />
    </g>
    <g
      v-for="hp in handsIPPointsXY"
      :key="hp.hand"
      class="svgchart_svg_content svgchart_hands svgchart_hands-ip"
      :style="`--stroke-unit:${hp.circle_size}`"
    >
      <path
        :d="`M ${hp.x} ${hp.y} l 0.0001 0`"
        vector-effect="non-scaling-stroke"
        class="svgchart_hands_circle svgchart_hands_circle_ip"
      />
    </g>
    <g
      v-for="hp in handsOOPPointsXY"
      :key="`oop_${hp.hand}`"
      class="svgchart_svg_content svgchart_hands svgchart_hands-oop"
      :style="`--stroke-unit:${hp.circle_size}`"
    >
      <path
        :d="`M ${hp.x} ${hp.y} l 0.0001 0`"
        vector-effect="non-scaling-stroke"
        class="svgchart_hands_circle svgchart_hands_circle_oop"
      />
    </g>
    <g
      v-for="(hp, idx) in pointsActiveXY"
      :key="`active_${hp.hand}_${idx}`"
      class="svgchart_svg_content svgchart_hands svgchart_hands-active"
      :style="`--stroke-unit:${hp.circle_size}`"
    >
      <!-- :id="`${hp.hand}_eq-percentile_${hp.x}_eq_${hp.eq}`" -->
      <path
        :d="`M ${hp.x} ${hp.y} l 0.0001 0`"
        vector-effect="non-scaling-stroke"
        style=""
        class="svgchart_hands_circle svgchart_hands_circle_active_border"
      />
      <path
        :d="`M ${hp.x} ${hp.y} l 0.0001 0`"
        vector-effect="non-scaling-stroke"
        :class="{ svgchart_hands_circle_active: hp.active }"
        class="svgchart_hands_circle svgchart_hands_circle_active"
      />
    </g>
    <g
      v-for="(hp, idx) in pointsPinnedXY"
      :key="`pinned_${hp.hand}_${idx}`"
      class="svgchart_svg_content svgchart_hands svgchart_hands-pinned"
      :style="`--stroke-unit:0.75`"
    >
      <!-- :style="`--stroke-unit:${hp.circle_size}`" -->
      <path
        :d="`M ${hp.x} ${hp.y} l 0.0001 0`"
        vector-effect="non-scaling-stroke"
        :class="{ svgchart_hands_circle_active: hp.active }"
        class="svgchart_hands_circle svgchart_hands_circle_pinned"
      />
    </g>
  </svg>
</template>

<script>
import SvgPath from '@/components/Charts/LineChart/SvgPath'

export default {
  name: 'ChartSvg',

  components: {
    SvgPath,
  },
  props: {
    ipPointsXY: Array,
    oopPointsXY: Array,
    handsIPPointsXY: Array,
    handsOOPPointsXY: Array,
    pointsActiveXY: Array,
    pointsPinnedXY: Array,
  },
}
</script>
<style lang="scss" scoped>
svg {
  display: block;
  background-clip: content-box, padding-box;
  overflow: visible;
  position: relative;
  z-index: 1;
}
.svgchart {
  &_svg {
    --content-opacity: 1;
    --axis-space: 1rem;
    --axis-spaceX: var(--axis-space);
    --axis-spaceY: var(--axis-space);
    --clr-svg-back: rgba(255, 255, 255, 0.05);
    --stroke-width: 2;
    --svg-radius: 0 4px 0 0;

    height: calc(100% - var(--axis-spaceY));
    width: calc(100% - var(--axis-spaceX));
    background: var(--clr-svg-back);
    border-radius: var(--svg-radius);

    position: absolute;
    right: 0;
    top: 0;
    &_content {
      opacity: var(--content-opacity);
    }
  }
  &_path {
    z-index: 0;
    position: relative;
    fill: transparent;
    stroke-width: var(--stroke-width);
    stroke-linecap: round;
    stroke-linejoin: round;
    shape-rendering: geometricPrecision;
    &_ip {
      stroke: var(--clr-player_ip);
    }
    &_oop {
      stroke: var(--clr-player_oop);
    }
  }
  &_hands {
    --stroke-unit: 1;
    --circle-stroke: clamp(5px, calc(13px * var(--stroke-unit)), 22px);
    --circle-stroke-border: clamp(5px, calc(15.5px * var(--stroke-unit)), 22px);
    &_circle {
      stroke-linecap: round;
      stroke-width: var(--circle-stroke);
      z-index: 1;
      &_ip {
        stroke: var(--clr-player_ip);
      }
      &_oop {
        stroke: var(--clr-player_oop);
      }
      &_active {
        stroke: var(--clr-yellow);
        z-index: 2;
        stroke-width: var(--circle-stroke);
        &_border {
          stroke-width: var(--circle-stroke-border);
          stroke: white;
        }
      }
      &_pinned {
        stroke: var(--clr-yellow);
        stroke-width: var(--circle-stroke-border);
        z-index: 3;
      }
    }
  }
}
</style>
